import React, { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import sortIcon from '../../../assets/New-images/sort-blue-icon.svg'
import { QUIZZALLREVIEWREQUESTSBYID } from '../../../config'

import {
  getAllLevels,
  getAllModulesFromYear,
} from '../../../store/knowledge/actions'
import { getAllQuizzes } from '../../../store/quizzes/actions'
import Select from 'react-select'
import ChildPageHeader from '@/components/UI/ChildPageHeader'
import { Quiz } from '@/models/quiz.model'
import { Button, Stack, Tooltip, Typography } from '@mui/material'

function QuizessPendingReview(props: any) {
  const { t } = useTranslation()
  const history = useHistory()
  const dispatch = useDispatch()

  const [years, setYears] = useState([])

  const [modules, setModules] = useState([])

  const [selectedGroupId, setSelectedGroupId] = useState(null)
  const { isArchive = false } = props
  const [filters, setFilters] = useState({
    sort_field: 'updated_at',
    sort_order: 'dsc',
    topic_ids: null,
    knowledge_group_ids: null,
    q: null,
    includes_all_subgroups: null,
    isArchive: isArchive,
  })
  const [quizzes, setQuizzes] = useState<Quiz[]>([])
  const [selectedChannel, setChannels] = useState(null)

  useEffect(() => {
    getAllYearsFun()
  }, [])

  useEffect(() => {
    // if (!selectedGroupId) {
    //   return;
    // }
    getAllQuizzesFun({
      ...filters,
      knowledge_group_ids: selectedGroupId,
      includes_all_subgroups: true,
    })
  }, [filters, selectedGroupId])

  const getAllQuizzesFun = async (filters: any) => {
    try {
      const response: any = await dispatch(getAllQuizzes(filters))
      const quiz = response.filter((q: Quiz) => {
        return q.reviews_count > 0
      })
      setQuizzes(quiz)
    } catch (error) {
      console.log('error', error)
    }
  }

  const getAllYearsFun = async (loadSubModules: boolean = true) => {
    try {
      const response: any = await dispatch(getAllLevels())
      setYears([...response])
      response &&
        response.length > 0 &&
        getAllModulesFromYearFun(
          selectedGroupId ? selectedGroupId : response[0]._id,
        )
    } catch (error: any) {
      setYears([])
    }
  }

  const getAllModulesFromYearFun = async (year: any) => {
    try {
      const response: any = await dispatch(getAllModulesFromYear(year))
      setModules([...response])
    } catch (error: any) {
      setModules([])
    }
  }

  /**
   * Set debounce time for while searching in any input
   */
  const [query, setQuery] = useState('')
  const [isTyping, setTyping] = useState(false)
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (isTyping) {
        // setCurrentPage(1);
        setFilters({
          ...filters,
          q: query,
        })
        setTyping(false)
      }
    }, 500)
    return () => clearTimeout(delayDebounceFn)
  }, [query])

  const onInputChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setQuery(e.target.value)
    setTyping(true)
  }

  const onSortHandler = (selector: any, direction: string) => {
    setFilters({
      ...filters,
      sort_field: selector,
      sort_order: direction,
    })
  }

  // get module names
  const getLevelNames = (levels: string[]) => {
    let moduleAsString: string[] = []

    levels.forEach(level => {
      const moduleObj = modules.find((m: any) => m.value === level)
      if (moduleObj) {
        moduleAsString.push(moduleObj.label)
      }
    })
    return moduleAsString.length === 0
      ? 'Uncategorised'
      : moduleAsString.join(', ')
  }

  const quizHtml = (
    <>
      <div className="all-knowledge-search d-flex flex-wrap align-items-center mb-2">
        <Dropdown className="mr-2 sort-dropdown">
          <Dropdown.Toggle
            className="btn btn-outline-primary font-600 py-1 my-1 "
            variant="default"
            id="dropdown-basic"
          >
            <img src={sortIcon} alt="" className="mr-2" />
            {t('Sort')}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('updated_at', 'dsc')
              }}
            >
              {t('Most Recent')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'asc')
              }}
            >
              {t('Ascending')}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                onSortHandler('name', 'dsc')
              }}
            >
              {t('Descending')}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <div className=" d-flex flex-wrap doc-select-dropdown">
          <Select
            className="select-sort select-target select-blue shadow-none radius-8 mr-2"
            classNamePrefix="select-target-prefix"
            isSearchable={false}
            placeholder={t('All Year')}
            options={years?.map(y => {
              return {
                value: y._id,
                label: y.name,
              }
            })}
            onChange={e => {
              setChannels(e)
              setSelectedGroupId(e.value)
            }}
            value={selectedChannel ? selectedChannel : null}
          />
        </div>

        <div className="web-links my-0 mr-0">
          <input
            type="text"
            className="form-control h-auto"
            placeholder={t('Search by quiz')}
            onChange={onInputChangeHandler}
          />
        </div>
      </div>

      <div className="tw-mt-4 tw-grid tw-gap-6 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4">
        {quizzes.map(quiz => {
          return (
            <Stack
              key={quiz._id}
              gap={3}
              className="tw-border tw-rounded-lg tw-px-6 tw-py-4 tw-cursor-pointer hover:tw-shadow"
              alignItems="flex-start"
            >
              <Stack gap="4px">
                <Typography variant="h4" sx={{ fontWeight: 700 }}>
                  {quiz.reviews_count}
                </Typography>
                <div className="tw-h-1 tw-rounded tw-w-28 tw-bg-preview" />
                <Typography variant="caption2" color="textGrey">
                  {t('Pending Review(s)')}
                </Typography>
              </Stack>
              <Stack gap={1}>
                <Tooltip title={quiz.name} placement="top-start">
                  <Typography
                    variant="subtitle2"
                    component="h5"
                    sx={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: '-webkit-box',
                      WebkitLineClamp: '2',
                      WebkitBoxOrient: 'vertical',
                    }}
                  >
                    {quiz.name}
                  </Typography>
                </Tooltip>
                <Typography variant="caption2" color="textGrey">
                  {getLevelNames(
                    quiz.knowledge_group_ids ? quiz.knowledge_group_ids : [],
                  )}
                </Typography>
              </Stack>
              <Button
                onClick={e => {
                  e?.stopPropagation()
                  history.push(
                    QUIZZALLREVIEWREQUESTSBYID.replace(':quizId', quiz._id),
                  )
                }}
              >
                {t('Review')}
              </Button>
            </Stack>
          )
        })}
      </div>
    </>
  )

  return (
    <section className="page-mid-wraper h-without-foter">
      <ChildPageHeader
        title={t('Quizzes Pending Review')}
        subTitle={t('View all quizzes that are pending review')}
      />
      <div className="knowledge-viewby col-lg-12 col-md-12">{quizHtml}</div>
    </section>
  )
}

export default QuizessPendingReview
